/* eslint-disable react/destructuring-assignment */
import React, { useContext } from "react";
import { string, shape, arrayOf, bool } from "prop-types";
import moment from "moment";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";
import FormattedAmount from "pages/_components/FormattedAmount";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import { isEmpty } from "lodash";
import CustomData from "../../../_components/CustomData/CustomData";
import getCellPlacement from "../../../../util/helpers/table";

const CesionSummaryBody = (props) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {}, creationDateTime = moment(), idTransaction = "" } = transaction;
    const { isDesktop } = props;
    const {
        beneficiary = props.beneficiary.document,
        beneficiaryName = props.beneficiary.reference,
        address = props.address,
        reference = props.reference,
        referencevalue = props.referencevalue,
        echeqList = props.echeqList,
        cesion = {},
        amount = {},
        coelsaResponse,
        coelsaCode,
    } = data;
    const { fecha_emision_cesion = null, cesion_id = "" } = cesion;
    const { currency, quantity } = amount;
    const showCesionInfo = idTransaction && !isEmpty(cesion);
    const alignX = "left";
    const alignY = "start";
    const columnTemplate = isDesktop ? "1fr 1fr 1fr" : "1fr";
    const getCellProps = (row, col, cols) => ({
        alignX,
        alignY,
        ...getCellPlacement(row, col, { isDesktop, totalColumns: cols }),
    });

    return (
        <>
            {idTransaction && (
                <GridTable className="box e-checks-summary p-0">
                    <GridTable.Container columns={3} rows={1}>
                        <GridTable.Data {...getCellProps(1, 1)}>
                            <CustomData
                                titleText="forms.transaction.ticket.dateAndHour"
                                titleTextType="I18N"
                                valueText={
                                    <CustomText
                                        textType="DATE"
                                        text={creationDateTime}
                                        dateFormat="DD/MM/YYYY HH:mm:ss"
                                    />
                                }
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data {...getCellProps(1, 2)}>
                            <CustomData
                                titleText="ticket.voucher"
                                titleTextType="I18N"
                                valueText={idTransaction.substring(0, 8).toUpperCase()}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
            )}

            {echeqList?.map((echeq) => (
                <GridTable className="box e-checks-summary px-0 pb-0">
                    <GridTable.Container columns={3} rows={5} columnsTemplate={columnTemplate}>
                        <GridTable.Data {...getCellProps(1, 1, 3)}>
                            <CustomData
                                titleText="echecks.number.label"
                                titleTextType="I18N"
                                valueText={echeq.cheque_numero}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data {...getCellProps(1, 2, 3)}>
                            <CustomData
                                titleText="echecks.beneficiary"
                                titleTextType="I18N"
                                valueText={beneficiaryName}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data {...getCellProps(1, 3, 3)}>
                            <CustomData
                                titleText="echecks.document"
                                titleTextType="I18N"
                                valueText={beneficiary}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>

                        <GridTable.Data {...getCellProps(2, 1, 3)}>
                            <CustomData
                                titleText="echecks.amount"
                                titleTextType="I18N"
                                valueText={<FormattedAmount currency={echeq.emisor_moneda} quantity={echeq.monto} />}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data {...getCellProps(2, 2, 3)}>
                            <CustomData
                                titleText="echecks.id.label"
                                titleTextType="I18N"
                                valueText={echeq.cheque_id}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data {...getCellProps(2, 3, 3)}>
                            <CustomData
                                titleText="echecks.address"
                                titleTextType="I18N"
                                valueText={address}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data {...getCellProps(3, 1, 3)}>
                            <CustomData titleText="echecks.currency" titleTextType="I18N" valueText={echeq?.moneda} />
                        </GridTable.Data>
                        <GridTable.Data {...getCellProps(3, 2, 3)}>
                            <CustomData
                                titleText="echecks.createdRange.label"
                                titleTextType="I18N"
                                valueText={<CustomText textType="DATE" text={echeq.fecha_emision} />}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data {...getCellProps(3, 3, 3)}>
                            <CustomData
                                titleText="echecks.payedRange.label"
                                titleTextType="I18N"
                                valueText={<CustomText textType="DATE" text={echeq.fecha_pago} />}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data {...getCellProps(4, 1, 3)}>
                            <CustomData
                                titleText="echecks.echeckType"
                                titleTextType="I18N"
                                valueText={echeq.cheque_tipo}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>

                        <GridTable.Data {...getCellProps(4, 2, 3)}>
                            <CustomData
                                titleText="echecks.echeckNature"
                                titleTextType="I18N"
                                valueText={echeq.cheque_caracter}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data {...getCellProps(4, 3, 3)}>
                            <CustomData
                                titleText="echecks.echeckMode"
                                titleTextType="I18N"
                                valueText={
                                    <CustomText
                                        textType="I18N"
                                        text={echeq.cheque_modo === 1 ? "echecks.emit.cross" : "echecks.emit.uncross"}
                                    />
                                }
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data {...getCellProps(5, 1, 3)}>
                            <CustomData
                                titleText="echecks.echeckConcept"
                                titleTextType="I18N"
                                valueText={
                                    <CustomText textType="I18N" text={`transfer.reasons.${echeq.cheque_concepto}`} />
                                }
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>

                        <GridTable.Data {...getCellProps(5, 2, 3)}>
                            <CustomData
                                titleText="echecks.emit.motive.label"
                                titleTextType="I18N"
                                valueText={echeq.cheque_motivo_pago}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>

                        <GridTable.Data {...getCellProps(5, 3, 3)}>
                            <CustomData
                                titleText="echecks.echeckReference"
                                titleTextType="I18N"
                                valueText={reference}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>

                        <GridTable.Data {...getCellProps(6, 1, 3)}>
                            <CustomData
                                titleText="echecks.echeckReferenceValue"
                                titleTextType="I18N"
                                valueText={referencevalue}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
            ))}

            {idTransaction && (
                <GridTable className="box e-checks-summary px-0">
                    <GridTable.Container columns={1} rows={1} columnsTemplate={columnTemplate}>
                        <GridTable.Data {...getCellProps(1, 1)}>
                            <CustomData
                                titleText="transaction.process.details.heading.totalAmount"
                                titleTextType="I18N"
                                valueText={
                                    <FormattedAmount className="data-label" currency={currency} quantity={quantity} />
                                }
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data {...getCellProps(1, 2)}>
                            <CustomData
                                titleText="echecks.response"
                                titleTextType="I18N"
                                valueText={coelsaResponse}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data {...getCellProps(1, 3)}>
                            <CustomData
                                titleText="echecks.codeMessage"
                                titleTextType="I18N"
                                valueText={coelsaCode}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
            )}

            {showCesionInfo && (
                <GridTable className="box e-checks-summary px-0">
                    <GridTable.Container columns={3} rows={1}>
                        <GridTable.Data {...getCellProps(1, 1)}>
                            <CustomData
                                titleText="echecks.cession.dateTime"
                                titleTextType="I18N"
                                valueText={fecha_emision_cesion}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data {...getCellProps(1, 2)}>
                            <CustomData
                                titleText="echecks.cession.cessionId"
                                titleTextType="I18N"
                                valueText={cesion_id}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
            )}
        </>
    );
};

CesionSummaryBody.propTypes = {
    beneficiary: shape({
        reference: string,
        document: string,
    }),
    echeqList: arrayOf(echeqPropTypes),
    address: string,
    referencevalue: string,
    reference: string,
    isDesktop: bool.isRequired,
};

CesionSummaryBody.defaultProps = {
    beneficiary: {
        reference: "",
        document: "",
    },
    echeqList: [],
    address: "",
    referencevalue: "",
    reference: "-",
};

export default CesionSummaryBody;
